export default function stubString() {
  return ''
}
